import React from 'react';

export const formatRfqDate = (value) => {
  if (!value) return '—';
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return '—';
  return date.toLocaleDateString('en-IN');
};

export const formatRfqDestination = (rfq, fallback = '—') => {
  if (!rfq) return fallback;
  const street = rfq.address || rfq.street || rfq.streetAddress || '';
  const city = rfq.city;
  const state = rfq.state;
  const zip = rfq.zip_code || rfq.zipCode || rfq.pinCode || rfq.pincode;
  const country = rfq.country;
  const streetText = String(street).trim();
  const lowerStreet = streetText.toLowerCase();
  const alreadyInStreet = (value) =>
    value && lowerStreet.includes(String(value).trim().toLowerCase());
  const parts = [
    streetText,
    alreadyInStreet(city) ? '' : city,
    alreadyInStreet(state) ? '' : state,
    alreadyInStreet(zip) ? '' : zip,
    alreadyInStreet(country) ? '' : country
  ].filter((value) => value != null && String(value).trim() !== '');
  return parts.length ? parts.join(', ') : fallback;
};

const Field = ({ label, value, className = '' }) => (
  <div className={`rounded-lg bg-gray-50 p-3 text-sm ${className}`}>
    <p className="text-gray-500">{label}</p>
    <p className="font-semibold text-gray-900">{value || '—'}</p>
  </div>
);

const DeliveryDetailsCard = ({ rfq, fallbackDestination = '—', className = '' }) => {
  if (!rfq) return null;

  return (
    <div className={`rounded-xl border border-gray-100 bg-white p-4 shadow-sm ${className}`}>
      <h3 className="text-base font-semibold text-[#1E4A53]">Delivery details</h3>
      <div className="mt-3 grid grid-cols-1 gap-3 md:grid-cols-2">
        <Field label="Expected date" value={formatRfqDate(rfq.deliveryDate || rfq.delivery_date)} />
        <Field label="Expiry date" value={formatRfqDate(rfq.expiryDate || rfq.expiry_date)} />
        <Field
          label="Destination"
          value={formatRfqDestination(rfq, fallbackDestination)}
          className="md:col-span-2"
        />
      </div>
    </div>
  );
};

export default DeliveryDetailsCard;
